/*** IMPORTS FROM imports-loader ***/
(function() {
var define = false;

'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _createClass = require('babel-runtime/helpers/create-class')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactRouter = require('react-router');

var _components = require('components');

var _lodashTakeRight = require('lodash/takeRight');

var _lodashTakeRight2 = _interopRequireDefault(_lodashTakeRight);

var _lodashMap = require('lodash/map');

var _lodashMap2 = _interopRequireDefault(_lodashMap);

var RecentNews = (function (_Component) {
	_inherits(RecentNews, _Component);

	function RecentNews() {
		_classCallCheck(this, _RecentNews);

		_Component.apply(this, arguments);
	}

	RecentNews.prototype.render = function render() {
		var styles = require('./RecentNews.css');

		var articles = _lodashTakeRight2['default'](this.props.articles, this.props.articles.length - 6);

		/* Map articles from API to <article/> elements */
		var articleRoll = _lodashMap2['default'](articles, function (article) {
			return _react2['default'].createElement(_components.ArticleRollItem, {
				author: article.author,
				categories: article.categories,
				content: article.excerpt,
				imageSrc: article.images['bbrew-small'][0],
				key: article.id,
				postDate: article.date,
				specialSeries: article.specialSeries || null,
				title: article.title,
				uri: article.url
			});
		});

		return _react2['default'].createElement(
			'div',
			{ className: styles.Base },
			_react2['default'].createElement(
				'h1',
				{ className: styles.Header },
				'Recent News'
			),
			_react2['default'].createElement(
				'div',
				{ className: styles.ArticleRoll },
				articleRoll
			),
			_react2['default'].createElement(
				_reactRouter.Link,
				{ className: styles.Link, to: '/more-news' },
				'More News'
			)
		);
	};

	_createClass(RecentNews, null, [{
		key: 'propTypes',
		value: {
			articles: _react.PropTypes.array,
			articleCount: _react.PropTypes.number
		},
		enumerable: true
	}]);

	var _RecentNews = RecentNews;
	RecentNews = _reactRedux.connect(function (state) {
		return {
			articles: state.articles.data
		};
	})(RecentNews) || RecentNews;
	return RecentNews;
})(_react.Component);

exports['default'] = RecentNews;
module.exports = exports['default'];
}.call(window));


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/RecentNews/RecentNews.js
 ** module id = 689
 ** module chunks = 0
 **/